
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/pygame",
      function () {
        return require("private-next-pages/courses/pygame.tsx");
      }
    ]);
  